import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import {
  CheckboxIcon,
  CheckmarkIcon,
  CustomCheckboxLabel,
  FormFieldWrapper,
  HiddenCheckbox,
} from './styles';

interface CustomCheckboxFieldProps extends FieldRenderProps<boolean> {
  label: string;
}

const CheckboxField: React.FC<CustomCheckboxFieldProps> = ({
  input,
  meta,
  label,
  ...rest
}) => {
  return (
    <FormFieldWrapper>
      <CustomCheckboxLabel>
        <HiddenCheckbox {...input} {...rest} />
        <CheckboxIcon />
        <CheckmarkIcon />
        {label}
      </CustomCheckboxLabel>
      <br />
      {meta.error && meta.touched && (
        <span className="error">{meta.error}</span>
      )}
    </FormFieldWrapper>
  );
};

export { CheckboxField };
